import styled from 'styled-components';
import { customMedia, cssBaseContainer } from 'styles/utils';

import Icon from 'components/Icon';
import Logo from 'components/Logo';

export const FooterMainStyled = styled.footer`
  background-color: ${props => props.theme.color.wfBlack};
  width: 100vw;
  min-height: 60vh;

  @media print {
    display: none;
  }
`;

export const FooterSmallMainStyled = styled(FooterMainStyled)`
  color: ${props => props.theme.color.wfGrey600};
  background-color: ${props => props.theme.color.wfGrey100};
  height: auto;
  min-height: auto;
`;

export const FooterNav = styled.nav`
  ${cssBaseContainer}
  display: flex;
  height: 100%;

  a {
    color: ${props => props.theme.color.wfWhite};
    &:hover {
      text-decoration: underline;
    }
  }

  ${customMedia.lessThan('large')`
    height: 58vh;
  `}

  ${customMedia.lessThan('medium')`
    height: auto;
    flex-direction: column;
    justify-content: space-between;
    padding: ${props =>
      `${props.theme.spacing.medium} ${props.theme.layout.paddingInline}`};
  `}
`;

export const FooterSmallNav = styled(FooterNav)`
  text-align: center;
  justify-content: space-between;

  ${customMedia.lessThan('large')`
    height: auto;
    align-items: center;
    padding: ${props =>
      `${props.theme.spacing.xlarge} ${props.theme.layout.paddingInline}`};
  `}
`;

export const FooterColumnWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  height: 100%;
`;

export const FooterInceptionMainWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 100%;

  ${customMedia.greaterThan('large')`
    max-width: 80vw;
  `}

  ${customMedia.lessThan('medium')`
    flex-direction: column;
  `}
`;

export const FooterInceptionWrapper = styled(FooterInceptionMainWrapper)`
  height: auto;
  align-items: flex-end;
`;

export const LogoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  width: 25vw;
  height: 100%;

  ${customMedia.lessThan('medium')`
    flex-direction: row;
    width: 100%;
    height: auto;
  `}
`;

export const LogoWrapperChild = styled.div`
  display: flex;
  ${customMedia.lessThan('medium')`
    width: 50%;
  `}
`;

export const CopyrightHeader = styled.div`
  ${customMedia.greaterThan('medium')`
    display: none;
     small {
       display: none;
     }
  `}
  ${customMedia.lessThan('medium')`
    small {
      display: flex;
    }
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    width: 50%;
    height: auto;
  `}
`;

export const PrimaryContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  ${customMedia.lessThan('large')`
    flex-direction: column-reverse;
    justify-content: center;
    align-items: center;
  `}
`;

export const PrimaryNav = styled.dl`
  font-size: ${props => props.theme.font.size.default};
  color: ${props => props.theme.color.wfGrey600};
  display: inline-block;
  vertical-align: top;
  dt {
    font-weight: ${props => props.theme.font.weight.xbold};
    margin-bottom: ${props => props.theme.spacing.default};
  }
  dd {
    margin-bottom: ${props => props.theme.spacing.default};
  }

  ${customMedia.lessThan('medium')`
    font-size: ${props => props.theme.font.size.small};
    width: 50%;
    margin-bottom: ${props => props.theme.spacing.large};
  `}
`;

export const RoutesContent = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding-top: ${props => props.theme.spacing.large};
`;

export const SecondaryNav = styled.ul`
  font-weight: ${props => props.theme.font.weight.xbold};
  font-size: ${props => props.theme.font.size.small};
  ${customMedia.lessThan('large')`
    margin: ${props => props.theme.spacing.large} 0;
  `}
`;

export const SecondaryItem = styled.li`
  display: inline-block;
  color: ${props => props.theme.color.wfGrey600};
  &:not(:last-child) {
    margin-right: ${props => props.theme.spacing.medium};
  }
  a {
    color: ${props => props.theme.color.wfGrey600};
  }
`;

export const LogoStyled = styled(Logo)`
  width: 100px;
`;

export const IconStyled = styled(Icon)`
  color: ${props => props.theme.color.wfWhite};
  vertical-align: bottom;
  transition: transform 100ms ease-in-out;
  margin-left: ${props => props.theme.spacing.default};
`;

export const SocialItem = styled.li`
  strong {
    font-weight: ${props => props.theme.font.weight.regular};
  }
  &::after {
    color: ${props => props.theme.color.wfWhite};
  }
  a:hover {
    ${IconStyled} {
      transform: scale(1.1);
    }
  }
`;

export const SocialLinks = styled.ul`
  ${SocialItem} {
    display: inline-block;
    strong {
      margin-left: ${props => props.theme.spacing.small};
    }
    &:first-child {
      ${IconStyled} {
        margin-left: 0;
      }
    }

    ${customMedia.lessThan('large')`
      display: inline-block;
      strong {
        display: inline-block;
      }
      ${IconStyled} {
        margin: ${props =>
          `0 ${props.hideText ? props.theme.spacing.medium : 0} 0 ${
            !props.hideText ? props.theme.spacing.medium : 0
          }`};
      }
      &:not(:first-child) {
        margin-top: ${props => props.theme.spacing.medium};
      }
    `}
  }

  ${customMedia.lessThan('large')`
    margin: -${props => props.theme.spacing.default} 0 0 0;
  `}
`;

export const CopyrightStyled = styled.small`
  color: ${props => props.theme.color.wfGrey500};
  font-size: ${props => props.theme.font.size.small};
  margin-top: ${props => props.theme.spacing.xsmall};

  ${customMedia.lessThan('large')`
    margin-top: 0;
  `}
  ${customMedia.lessThan('medium')`
    display: ${props => (props.main ? 'none' : 'flex')};
  `}
`;

export const ChinaLinkStyled = styled.div`
  display: ${props => (props.mobile ? 'none' : 'flex')};

  a {
    color: ${props => props.theme.color.wfGrey500};
    font-size: ${props => props.theme.font.size.small};
    margin-top: ${props => props.theme.spacing.xsmall};
  }

  img {
    margin-right: 0.5rem;
  }

  ${customMedia.lessThan('large')`
    display: ${props =>
      props.hiddenMediumToLarge
        ? 'none'
        : props.mobile || props.main
        ? 'flex'
        : 'none'};
    margin: 0 0 ${props => props.theme.spacing.default} 0;
  `}
  ${customMedia.lessThan('medium')`
    display: ${props => (props.mobile ? 'flex' : 'none')};
    margin-bottom: ${props => props.theme.spacing.default};
  `}
`;

export const ChinaIDsColumn = styled.div`
  display: ${props => (props.mobile ? 'none' : 'flex')};
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  height: 3rem;

  ${customMedia.lessThan('medium')`
    display: ${props => (props.mobile ? 'flex' : 'none')};
    align-items: flex-start;
    height: auto;
  `}
`;
